module.exports = __webpack_public_path__ + "static/media/g1.b35b7bd1.jpg";